import { colors, defaultColor, Color } from "./colors";
import { Size } from "./size";

export default function TextPlusElements({
  color,
  fontSize,
  children,
}: {
  color?: Color;
  fontSize?: Size;
  children: JSX.Element;
}) {
  return (
    <p
      style={{
        color: colors[color ?? defaultColor],
        fontSize: fontSize ?? "1rem",
      }}
    >
      {children}
    </p>
  );
}
